import PropTypes from 'prop-types'
import React from 'react'

import { UNIT_TYPES } from 'constants'
import { BATTLE_TITLES } from 'helpers/i18n'
import { BATTLE_TITLE_TOOLTIPS_ID } from '../../constants.jsx'
import {
    FORT_BATTLE_CONTENTS,
    SORTIE_CONTENTS,
    DESCRIPTION_SUBTITLE,
    REWARD_SUBTITLE,
} from './constants.jsx'

import { Tooltip } from 'react-wot-bootstrap'
import { Schedule } from '../../components'

import styles from './BattleTitleTooltip.scss'

const BattleTitleTooltip = (props) => {
    let scheduleComponent
    if (props.showSchedule) scheduleComponent = (
        <div className={styles.schedule}>
            <Schedule peripheries={props.peripheries} type={props.type} tooltip />
        </div>
    )

    let contents
    switch (props.type) {
    case UNIT_TYPES.SORTIE:
        contents = (
            <div className={styles.contents}>
                <p>{SORTIE_CONTENTS.definition}</p>
                {scheduleComponent}
                <h4 className={styles.subtitle}>{DESCRIPTION_SUBTITLE}</h4>
                <p>{SORTIE_CONTENTS.description}</p>
                <div className={styles.reward}>
                    <h4 className={styles.rewardSubtitle}>{REWARD_SUBTITLE}</h4>
                    <p>{SORTIE_CONTENTS.reward}</p>
                </div>
            </div>
        )
        break
    case UNIT_TYPES.FORT_BATTLE: {

        const fortBattleModeDescription = FORT_BATTLE_CONTENTS.description.map((item, idx) => {
            return (
                <li className={styles.item} key={idx}>{item}</li>
            )
        })
        contents = (
            <div className={styles.contents}>
                <p>{FORT_BATTLE_CONTENTS.definition}</p>
                {scheduleComponent}
                <h4 className={styles.subtitle}>{DESCRIPTION_SUBTITLE}</h4>
                <ul className={styles.list}>{fortBattleModeDescription}</ul>
                <div className={styles.reward}>
                    <h4 className={styles.rewardSubtitle}>{REWARD_SUBTITLE}</h4>
                    <p>{FORT_BATTLE_CONTENTS.reward}</p>
                </div>
            </div>
        )
        break
    }
    }

    return (
        <Tooltip id={BATTLE_TITLE_TOOLTIPS_ID[props.type]} isWide>
            <h3 className={styles.title}>{BATTLE_TITLES[props.type]}</h3>
            {contents}
        </Tooltip>
    )
}

BattleTitleTooltip.propTypes = {
    type: PropTypes.oneOf(Object.values(UNIT_TYPES)).isRequired,
    peripheries: PropTypes.array.isRequired,
    showSchedule: PropTypes.bool,
}

export default BattleTitleTooltip



// WEBPACK FOOTER //
// ./components/BattleWizard/components/BattleTitleTooltip/BattleTitleTooltip.jsx